import { AuthenticateWithRedirectCallback } from "@clerk/react";
import { memo } from "react";
import { useSearchParams } from "react-router-dom";
import { getClerkConsumerPublishableKey } from "../auth/clerkPublishableKey";
import { consumerClerkSignInUrl } from "../auth/resume";
import { AuthMissingKey } from "./AuthPage";

export const SsoCallbackPage = memo(() => {
  const [searchParams] = useSearchParams();

  if (!getClerkConsumerPublishableKey()) {
    return <AuthMissingKey />;
  }

  // Every outcome of the IdP round-trip, including a cancel, has to land on
  // the widget auth page. Without signInUrl / signUpUrl, Clerk's callback
  // falls through to the Account Portal (*.accounts.dev/sign-in).
  const returnUrl = consumerClerkSignInUrl({
    origin: window.location.origin,
    search: searchParams.toString(),
  });

  return (
    <AuthenticateWithRedirectCallback
      signInUrl={returnUrl}
      signUpUrl={returnUrl}
      signInFallbackRedirectUrl={returnUrl}
      signUpFallbackRedirectUrl={returnUrl}
      signInForceRedirectUrl={returnUrl}
      signUpForceRedirectUrl={returnUrl}
      continueSignUpUrl={returnUrl}
    />
  );
});
